export class WizardFlowCustomerPreferences {
    gatherAssetsDigitally: number = 0;
    doNotRunCredit: number = 0;
    gatherEmploymentAndIncomeDigitally: number = 0;
    showHoiQuotes: boolean = true;
    alreadyHasHoiQuote: boolean | undefined | null = null;
}
